import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { orderActions, orderSelectors } from "../ducks/order";

export const useOrder = (orderId?: string) => {
  const dispatch = useDispatch();

  const orderHistories = useSelector(orderSelectors.orderHistories);

  useEffect(() => {
    dispatch(
      orderActions.getOrderHistory.started({
        conditions: orderId
          ? [
              {
                name: "注文ID",
                operator: "equal",
                value: orderId,
              },
            ]
          : [],
      }),
    );
  }, []);

  return { orderHistories };
};
